import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../axios/axios";
import moment from "moment";
import { Button, Form } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { DATE_TIME_FORMAT } from "../../constants/constants";
import { adminConfig } from "../../utils/adminConfig";

export default function SubscriptionCanceledReports() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");

  const columns = [
    {
      name: "Name",
      selector: ({ name }) => name,
      width: "300px",
    },
    {
      name: "Email",
      selector: ({ email }) => email,
      width: "350px",
    },
    {
      name: "UserName",
      selector: ({ userName }) => userName,
      width: "350px",
    },
    {
      name: "Phone",
      selector: ({ phone }) => phone,
      width: "150px",
    },
    {
      name: "Address",
      selector: ({ address }) => address,
      width: "350px",
    },
    {
      name: "Status",
      selector: ({ status }) => (status ? "Active" : "Inactive"),
      width: "200px",
    },
    {
      name: "Canceled At",
      selector: ({ createdAt }) => moment(createdAt).format(DATE_TIME_FORMAT),
      width: "200px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "17px",
        color: "#004aad",
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "16px",
      },
    },
  };

  useEffect(() => {
    getAllActiveMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search, startDate, endDate]);

  const getAllActiveMembers = () => {
    setLoading(true);
    axios
      .get(
        `/reports/subscription-canceled?source=tvi&page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/reports/csv-subscription-canceled?source=tvi&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            Name: member.name,
            Email: member.email,
            UserName: member.userName,
            Phone: member.phone,
            Address: member.address,
            Status: member.status ? "Active" : "Inactive",
            CanceledAt: moment(member.createdAt).format("MM-DD-YYYY, h:mm a"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();

            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Name", key: "Name" },
    { label: "Email", key: "Email" },
    { label: "UserName", key: "UserName" },
    { label: "Phone", key: "Phone" },
    { label: "Address", key: "Address" },
    { label: "Status", key: "Status" },
    { label: "Canceled At", key: "CanceledAt" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Subscription Canceled Members</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>
                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or email or phone or username"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>
                    <Form.Group controlId="formBasicEmail" className="dt_range">
                      <Form.Label>Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={selectedStartDate}
                        max={selectedEndDate || moment().format("YYYY-MM-DD")}
                        onChange={(e) => setSelectedStartDate(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="dt_range">
                      <Form.Label>End Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={selectedEndDate}
                        min={selectedStartDate}
                        max={moment().format("YYYY-MM-DD")}
                        onChange={(e) => setSelectedEndDate(e.target.value)}
                      />
                    </Form.Group>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setStartDate(selectedStartDate);
                        setEndDate(selectedEndDate);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      onClick={() => {
                        setSelectedStartDate("");
                        setSelectedEndDate("");
                        setStartDate("");
                        setEndDate("");
                        setQuery("");
                        setSearch("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`subscription_canceled_members.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={members.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
